module.exports = __webpack_public_path__ + "img/aliaksandr.s__600x600.6bbd7f26.jpg";